import { PlanType } from "./plan-type";

export enum LicenseLimit {
    Starter = 5,
    Trial = 10,
    Business = 10,
    ThirdParty = 1000000,
    Core = 30,
    Pro = 50,
    External = 1000000
}

export const LicenseLimitPlanType: { [key: number | PlanType]: LicenseLimit } = {
    [PlanType.Business]: LicenseLimit.Business,
    [PlanType.Trial]: LicenseLimit.Trial,
    [PlanType.Core]: LicenseLimit.Core,
    [PlanType.Pro]: LicenseLimit.Pro,
}